module.exports = __webpack_public_path__ + "img/download.44ff6fb3.png";